import { CMSFooterView } from '@modules/Nzo.CMS/Frontend/libraries/cmsFooter/cmsFooter.template'
import { NavItem, ParentNavItem } from '@shared/Frontend/components/navItems'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { Link } from '@shared/Frontend/utils/link'
import { getSite } from '@shared/Frontend/utils/site'
import { SVGIcon } from '@shared/Frontend/utils/svg'
import { translate } from '@shared/Frontend/utils/translate'
import i18next from 'i18next'
import React, { ReactNode } from 'react'

const site = getSite()
console.info(site)

export const CMSFooter: CMSFooterView['CMSFooter'] = ({ menuItems }) => (
  <>
    {site == 'ZEG' && (
      <div className='sf__intro'>
        <p className='text--md'>Zuivelengezondheid.nl is een platform voor gezondheidsprofessionals met wetenschappelijke informatie over voeding, zuivel en gezondheid.</p>
      </div>
    )}

    <div className="sf__fat">
      <nav className="sf__columns" aria-label={translate('common:footer:a11y', {}, 'Footer')}>
        <div className="sf__column sf__column--contact">
          <ContactInfo />
          <SocialNav />
        </div>
        <div className="sf__columns sf__column--menu">
          {menuItems.map((menuItem) => (
            <div className="sf__menuwrap">
              <p className={`sf__title ${site == 'ZEG' ? 'text--md' : 'title--xxs'}`}>{menuItem.label}</p>
              <ul className={`sf__menu ${site == 'ZEG' ? 'text--md' : 'text--sm'}`}>
                {menuItem.subNav?.map(
                  (item, k) =>
                    item.url &&
                    item.label && (
                      <NavItem
                        key={k}
                        label={item.label || ''}
                        url={item.url || ''}
                        isActive={false}
                        external={false}
                        itemClassName="sf__menuitem"
                        linkClassName='sf__menulink text--md'
                        onClick={() =>
                          pushDatalayer({
                            category: 'footer',
                            action: 'footer_button_click',
                            label: item.label,
                            menuType: 'sub',
                          })
                        }
                      />
                    )
                )}
              </ul>
            </div>
          ))}
        </div>
      </nav>
    </div>

    <div className="sf__skinny">
      <nav className="sf__column sf__column--legal text--sm" aria-label={translate('common:footer:a11yLegal', {}, 'Legal')}>
        <p className="copyright">© {new Date().getFullYear()} {i18next.language == 'en' ? 'Dutch Dairy Association' : 'Nederlandse Zuivel Organisatie'}</p>
        <div className="sf__legal legal">
          <ul className="legal__list">
            <li className="legal__item">
              <a className="sf__link legal__link text--sm" href={translate('common:footer:privacyUrl', {})}>{translate('common:footer:privacy', {}, 'Privacy')}</a>
            </li>
            <li className="legal__item">
              <a className="sf__link legal__link text--sm" href={translate('common:footer:cookiesUrl', {})}>{translate('common:footer:cookies', {}, 'Cookies')}</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </>
)

const ContactInfo = () => (
  <div className="sf__logo">
    <Link className='sf__logolink' url={`/${i18next.language}`} external={false} title={translate('a11y:toHomePage', {}, 'To home')}>
      <span className="sr-text">{translate('a11y:toHomePage', {}, 'To home')}</span>
      <img loading="lazy" className='sf__logoimg' src={i18next.language == 'en' ? "/images/spa/logo-footer--en.svg" : "/images/spa/logo-footer.svg"} width="208" height="168" alt={i18next.language == 'en' ? "Logo 'Dutch Dairy Association'" : "Logo 'Nederlandse Zuivel Organisatie'"} aria-hidden="true" />
    </Link>
  </div>
)

export const SocialNav = () => (
  <div className="sf__socials socials" aria-label="Socials">
    <ul className="socials__list">
      {site == 'ZEG' ? (
        <SocialItem name="Facebook" url={translate('common:footer:facebookUrl', {}, '#')}>
          <SVGIcon className="socials__icon" id="icon-facebook" size={24} />
        </SocialItem>
      ) : (
        <>
          <SocialItem name="LinkedIn" url={translate('common:footer:linkedinUrl', {}, '#')}>
            <SVGIcon className="socials__icon" id="icon-linkedin" size={24} />
          </SocialItem>

          <SocialItem name="Youtube" url={translate('common:footer:youtubeUrl', {}, '#')}>
            <SVGIcon className="socials__icon" id="icon-youtube-1" size={24} />
          </SocialItem>
        </>
      )}
    </ul>
  </div>
)

const SocialItem = ({ name, url, children }: { name: string; url: string; children: ReactNode }) => {
  const srText = translate('common:footer:followUsA11Y', {}, 'Follow us on') + ` ${name}`
  return (
    <li className="socials__item">
      <a className="socials__link" href={url} title={srText} target="_blank" rel="noopener noreferrer">
        <span className="sr-text">{srText}</span>
        {children}
      </a>
    </li>
  )
}
